"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CEKError = void 0;
var CEKError = /** @class */ (function () {
    function CEKError(msg, addInfos) {
        this.msg = msg;
        this.addInfos = addInfos;
    }
    ;
    CEKError.prototype.clone = function () {
        return new CEKError(this.msg, this.addInfos);
    };
    CEKError.fromUplc = function (uplc, addInfos) {
        var _a, _b;
        return new CEKError((_a = uplc.msg) !== null && _a !== void 0 ? _a : "explicit error from uplc", (_b = uplc.addInfos) !== null && _b !== void 0 ? _b : addInfos);
    };
    return CEKError;
}());
exports.CEKError = CEKError;
